import(/* webpackMode: "eager", webpackExports: ["NavigationContextProvider"] */ "/app/apps/nextjs/src/hooks/useNavigationState.tsx");
